import { Component, OnInit, TemplateRef } from '@angular/core';

import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators, PatternValidator } from '@angular/forms';

import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../Shared/commondialog/commondialog.component';
import { AdminAccessrightService } from './accessrightsadmin.service';
import { User } from '../Master/user/user';
import { UsermgtComponent } from '../usermgt/usermgt.component';
import { Accessrequest } from '../accessrequest/accessrequest';
import { NgxSpinnerService } from "ngx-spinner";												
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { LocalService } from '../local.service';

@Component({
  selector: 'app-accessrightsadmin',
  templateUrl: './accessrightsadmin.component.html',
  styleUrls: ['./accessrightsadmin.component.css']
})
export class AccessrightsadminComponent implements OnInit { 
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  accessrequests: Accessrequest[]=[];
  
  confirmsg: string;
  constructor(
    private adminaccessrightService: AdminAccessrightService,   
    private router: Router,
	 private SpinnerService: NgxSpinnerService,										  
    private toastr: ToastrService, private dialogService: DialogService, private usermgt: UsermgtComponent, 
    private navMenu: NavMenuComponent, private localService: LocalService) {

  }

  //get f() { return this.userForm.controls; }
  ngOnInit() {    
    this.searchText = '';
    this.getAll();
	this.SpinnerService.show();						   
  }

  getAll() {
    
		 this.SpinnerService.show();					   
    this.adminaccessrightService.Get().subscribe(res => {
      this.accessrequests = res;
	  this.SpinnerService.hide();
    }, error => { 
	this.SpinnerService.hide();
	this.toastr.error('error while getting Data'); });

  }


  changestatus(operationtype: string, accessrequests?: Accessrequest) {

    //accessrequests.approvedby = +localStorage.getItem("userid");
    accessrequests.approvedby = +this.localService.getJsonValue("userid");

    if (operationtype == "Accept")
    {
      this.SpinnerService.show(); 
      this.confirmsg = "Accept";
      accessrequests.approvedstatus = 1;
      this.adminaccessrightService.Put(accessrequests).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            this.SpinnerService.hide();
            if (res.body != 0) {
            
              this.getAll();
              this.usermgt.accesscount = this.accessrequests.length;
              this.toastr.success('Status Changed Successfully');
              this.router.navigate(['/home/useradd'], { queryParams: { userid: res.body, accessrightsflag: 1 } });
              this.navMenu.LoadAccessCount();
              //this.adminaccessrightService.Get().subscribe(res1 => {
              //  this.usermgt.accesscount = this.accessrequests.length;
              // // this.router.navigate(['/home/useradd'], { queryParams: { userid: user.userid } });

              //  //this.router.navigate(['/home/useradd'], { queryParams: { userid: user.userid, accessrightsflag: 1 } });

              // // this.router.navigate(['/home/useradd'], { queryParams: { userid: res.body, accessrightsflag: 1 } });

              //}, error => { });

            }
          }
        };
      },
        error => {
          this.SpinnerService.hide();
          this.toastr.error("Error While doing the operation");
          
        });

    }

    if (operationtype == "Reject") {
      this.confirmsg = "reject";
      accessrequests.approvedstatus = 0;

      let showpopup = this.dialogService.addDialog(CommondialogComponent,
        {
          title: 'Please Confirm',
          message: 'Are you sure you want to ' + this.confirmsg + ' this record ?',
          hclass: 'modelsuccess',
          oktext: 'Yes',
          canceltext: 'No',
          okshow: true,
          cancelshow: true
        }).subscribe((isConfirmed) => {
          if (isConfirmed) {
            this.SpinnerService.show();
            this.adminaccessrightService.Put(accessrequests).toPromise().then(res => {
              if (res.status == 200) {
                //if (res != undefined) {
                //  if (res.body != 0) {
                    this.accessrequests = [];
                    this.getAll();
                    this.usermgt.accesscount = this.accessrequests.length;
                    this.toastr.success('Status Changed Successfully');
                    this.navMenu.LoadAccessCount();
                    //this.adminaccessrightService.Get().toPromise().then(res => {
                    //  this.usermgt.accesscount = this.accessrequests.length;

                    //}, error => { });

                 // }
               // }
                this.SpinnerService.hide();
              };
            },
              error => {
                this.SpinnerService.hide();
                this.toastr.error("Error While doing the operation");

              });
           // location.reload();
          }

        });
    }

   


   

  }

  
}
